import { render, staticRenderFns } from "./pets.vue?vue&type=template&id=8b075b36&scoped=true"
import script from "./pets.vue?vue&type=script&lang=js"
export * from "./pets.vue?vue&type=script&lang=js"
import style0 from "./pets.vue?vue&type=style&index=0&id=8b075b36&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8b075b36",
  null
  
)

export default component.exports